if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const areaCodeInputData = document.getElementById("areaCodeInput");
        const lettersInputData = document.getElementById("lettersInput");
        const digitsInputData = document.getElementById("digitsInput");
        
        const seasonStartSelectData = document.getElementById("season-start-select");
        const seasonEndSelectData = document.getElementById("season-end-select");


        
        let vorschau = '';

        // is this an electric or historic license plate?
        let suffix = '';
  
        if (productMetafields.is_electric) {
          suffix = 'E';
        } else if (productMetafields.is_historic) {
          suffix = 'H';
        }else{
          
        }
        

        if (areaCodeInputData && lettersInputData && digitsInputData) {
          vorschau = areaCodeInputData.value.toUpperCase() + '-' + lettersInputData.value.toUpperCase() + '' + digitsInputData.value+''+suffix;
          document.querySelector('form #license').value = vorschau;
          document.querySelector('form #licenseArea').value = areaCodeInputData.value;
          document.querySelector('form #licenseLetters').value = lettersInputData.value;
          document.querySelector('form #licenseDigits').value = digitsInputData.value;
        }

        if(seasonStartSelectData && seasonEndSelectData){
          if(seasonStartSelectData.value > 0 && seasonEndSelectData.value > 0){
            document.querySelector('form #propSeason').value = seasonStartSelectData.value + '-' + seasonEndSelectData.value;
            document.querySelector('form #propLicenseSeasonStart').value = seasonStartSelectData.value;
            document.querySelector('form #propLicenseSeasonEnd').value = seasonEndSelectData.value;
          }
        }

        const formData = new FormData(this.form);

        
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
        
        //console.log(formData);
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              
              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              //console.log('cartData',response);
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              //console.log('quickAddModal');
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                    setCartItemLicenseAreaImage();
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              setCartItemLicenseAreaImage();

              
              // we need to make this conditional
              // on mobile we redirect the user to the cart
              // on desktop we continue to show the cart drawer
              if (window.innerWidth > 900) {
                this.cart.renderContents(response);
              }else{
                let oneOffStopCartForwarding = JSON.parse(localStorage.getItem('oneOffStopCartForwarding'));
               // console.log('oneOffStopCartForwarding', oneOffStopCartForwarding);
                if(oneOffStopCartForwarding){
                  // do nothing
                }else{
                  const cheeringContainer = document.querySelector('.cheering-container');
                  if(cheeringContainer){
                    cheeringContainer.classList.add('show');
                    setTimeout(() => {
                      cheeringContainer.classList.remove('show');
                      window.location="/cart";
                    }, 1500);
                  }else{
                    window.location="/cart";
                  }
                }
                localStorage.setItem('oneOffStopCartForwarding', false);
              }
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            if (window.innerWidth > 900) {
              this.submitButton.classList.remove('loading');
              this.querySelector('.loading__spinner').classList.add('hidden');
            }
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
